import React from "react";
import { HashLink as Link } from 'react-router-hash-link';
import { Button } from "semantic-ui-react";
import { useStore } from "../../app/stores/store";
import "../Certificacion/Curso.css";

interface Props {
    codigo: any;
    arancel: any;
}

export default function PagoModalPost(props: Props) {
    const {userStore: {user}, modalStore} = useStore();
    return(
        <div className="modal_pago_post">
            <h1>Pre-Inscripcion realizada exitosamente</h1>
            <p>Te has Pre-Inscrito satisfactoriamente. Pronto nos estaremos comunicando contigo, para que puedas continuar con el proceso de ingreso.</p>
            
            <div className="contenido_pago">
                <b>Codigo de referencia:</b>
                <p>{props.codigo}</p>                              
            </div>
            
            <div className="botones_pago">
                <Button color="blue" onClick={() => {
                    modalStore.closeModal()
                }}>Cerrar
                </Button>
            </div>
        </div>
    )
}